export default __webpack_public_path__ + "static/media/etapa6.e09463c5.png";